/**
 * Creates a getNextPageParam function for the useODatReadInfiniteApi hook.
 */
export const getNextPageParam = (pageLength, endpointName, rowCount, setRowCount) => (last, all) => {
    // Set the row count for the table
    if (last && last['@odata.count'] && last['@odata.count'] !== rowCount) {
        setRowCount(last['@odata.count']);
        // Todo: if row count suddenly doesn't match, should we clear the cache?
    }
    if (pageLength && last.value && last.value.length > pageLength) {
        console.error(endpointName, `API was given a page length of ${pageLength} items but returned ${last.value.length}.`, `This indicates an issue with the API's paging.`, `Please check the API endpoint: ${endpointName}`);
    }
    // Handles server-driven paging
    if (pageLength === undefined) {
        return last === null || last === void 0 ? void 0 : last['@odata.nextLink'];
    }
    // Catch the final page on client-driven paging
    if (!last ||
        last.value.length === 0 ||
        (pageLength !== undefined && last.value.length < pageLength)) {
        return false;
    }
    if (!all || all.length === 0) {
        return 0;
    }
    return all.length;
};
